
/* !!! This is code generated by Prisma. Do not edit directly. !!! */
/* eslint-disable */
// biome-ignore-all lint: generated file
// @ts-nocheck 
/*
 * WARNING: This is an internal file that is subject to change!
 *
 * 🛑 Under no circumstances should you import this file directly! 🛑
 *
 * All exports from this file are wrapped under a `Prisma` namespace object in the browser.ts file.
 * While this enables partial backward compatibility, it is not part of the stable public API.
 *
 * If you are looking for your Models, Enums, and Input Types, please import them from the respective
 * model files in the `model` directory!
 */

import * as runtime from "@prisma/client/runtime/index-browser"

export type * from '../models.ts'
export type * from './prismaNamespace.ts'

export const Decimal = runtime.Decimal


export const NullTypes = {
  DbNull: runtime.NullTypes.DbNull as (new (secret: never) => typeof runtime.DbNull),
  JsonNull: runtime.NullTypes.JsonNull as (new (secret: never) => typeof runtime.JsonNull),
  AnyNull: runtime.NullTypes.AnyNull as (new (secret: never) => typeof runtime.AnyNull),
}
/**
 * Helper for filtering JSON entries that have `null` on the database (empty on the db)
 *
 * @see https://www.prisma.io/docs/concepts/components/prisma-client/working-with-fields/working-with-json-fields#filtering-on-a-json-field
 */
export const DbNull = runtime.DbNull

/**
 * Helper for filtering JSON entries that have JSON `null` values (not empty on the db)
 *
 * @see https://www.prisma.io/docs/concepts/components/prisma-client/working-with-fields/working-with-json-fields#filtering-on-a-json-field
 */
export const JsonNull = runtime.JsonNull

/**
 * Helper for filtering JSON entries that are `Prisma.DbNull` or `Prisma.JsonNull`
 *
 * @see https://www.prisma.io/docs/concepts/components/prisma-client/working-with-fields/working-with-json-fields#filtering-on-a-json-field
 */
export const AnyNull = runtime.AnyNull


export const ModelName = {
  User: 'User',
  AdminApiToken: 'AdminApiToken',
  Invite: 'Invite',
  Session: 'Session',
  AuthSession: 'AuthSession',
  Account: 'Account',
  Verification: 'Verification',
  Token: 'Token',
  Project: 'Project',
  McpDraft: 'McpDraft',
  Membership: 'Membership',
  Contact: 'Contact',
  Operator: 'Operator',
  Subsection: 'Subsection',
  NetworkHierarchy: 'NetworkHierarchy',
  Subsubsection: 'Subsubsection',
  Parcel: 'Parcel',
  AcquisitionAreaStatus: 'AcquisitionAreaStatus',
  AcquisitionArea: 'AcquisitionArea',
  QualityLevel: 'QualityLevel',
  SubsubsectionStatus: 'SubsubsectionStatus',
  SubsubsectionTask: 'SubsubsectionTask',
  SubsubsectionInfra: 'SubsubsectionInfra',
  SubsubsectionInfrastructureType: 'SubsubsectionInfrastructureType',
  SubsubsectionSpecial: 'SubsubsectionSpecial',
  SubsectionStatus: 'SubsectionStatus',
  Upload: 'Upload',
  SupportDocument: 'SupportDocument',
  Survey: 'Survey',
  SurveySession: 'SurveySession',
  SurveyResponse: 'SurveyResponse',
  SurveyResponseTag: 'SurveyResponseTag',
  SurveyResponseComment: 'SurveyResponseComment',
  EmailTemplate: 'EmailTemplate',
  EvaluationsPage: 'EvaluationsPage',
  SystemLogEntry: 'SystemLogEntry',
  LogEntry: 'LogEntry',
  ProjectRecordEmail: 'ProjectRecordEmail',
  ProjectRecord: 'ProjectRecord',
  ProjectRecordComment: 'ProjectRecordComment',
  Tag: 'Tag',
  ProjectRecordTemplate: 'ProjectRecordTemplate',
  FormTemplate: 'FormTemplate',
  Meta: 'Meta'
} as const

export type ModelName = (typeof ModelName)[keyof typeof ModelName]

/*
 * Enums
 */

export const TransactionIsolationLevel = runtime.makeStrictEnum({
  ReadUncommitted: 'ReadUncommitted',
  ReadCommitted: 'ReadCommitted',
  RepeatableRead: 'RepeatableRead',
  Serializable: 'Serializable'
} as const)

export type TransactionIsolationLevel = (typeof TransactionIsolationLevel)[keyof typeof TransactionIsolationLevel]


export const UserScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  email: 'email',
  emailVerified: 'emailVerified',
  hashedPassword: 'hashedPassword',
  image: 'image',
  name: 'name',
  passwordHashMigratedAt: 'passwordHashMigratedAt',
  passwordResetRequired: 'passwordResetRequired',
  role: 'role',
  firstName: 'firstName',
  lastName: 'lastName',
  phone: 'phone',
  institution: 'institution'
} as const

export type UserScalarFieldEnum = (typeof UserScalarFieldEnum)[keyof typeof UserScalarFieldEnum]


export const AdminApiTokenScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name',
  hashedToken: 'hashedToken',
  lastUsedAt: 'lastUsedAt',
  revokedAt: 'revokedAt',
  createdById: 'createdById'
} as const

export type AdminApiTokenScalarFieldEnum = (typeof AdminApiTokenScalarFieldEnum)[keyof typeof AdminApiTokenScalarFieldEnum]


export const InviteScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  token: 'token',
  status: 'status',
  email: 'email',
  role: 'role',
  projectId: 'projectId',
  inviterId: 'inviterId'
} as const

export type InviteScalarFieldEnum = (typeof InviteScalarFieldEnum)[keyof typeof InviteScalarFieldEnum]


export const SessionScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  expiresAt: 'expiresAt',
  handle: 'handle',
  hashedSessionToken: 'hashedSessionToken',
  antiCSRFToken: 'antiCSRFToken',
  publicData: 'publicData',
  privateData: 'privateData',
  userId: 'userId'
} as const

export type SessionScalarFieldEnum = (typeof SessionScalarFieldEnum)[keyof typeof SessionScalarFieldEnum]


export const AuthSessionScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  expiresAt: 'expiresAt',
  ipAddress: 'ipAddress',
  token: 'token',
  userAgent: 'userAgent',
  userId: 'userId'
} as const

export type AuthSessionScalarFieldEnum = (typeof AuthSessionScalarFieldEnum)[keyof typeof AuthSessionScalarFieldEnum]


export const AccountScalarFieldEnum = {
  id: 'id',
  accountId: 'accountId',
  providerId: 'providerId',
  accessToken: 'accessToken',
  accessTokenExpiresAt: 'accessTokenExpiresAt',
  idToken: 'idToken',
  password: 'password',
  refreshToken: 'refreshToken',
  refreshTokenExpiresAt: 'refreshTokenExpiresAt',
  scope: 'scope',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  userId: 'userId'
} as const

export type AccountScalarFieldEnum = (typeof AccountScalarFieldEnum)[keyof typeof AccountScalarFieldEnum]


export const VerificationScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  expiresAt: 'expiresAt',
  identifier: 'identifier',
  value: 'value',
  userId: 'userId'
} as const

export type VerificationScalarFieldEnum = (typeof VerificationScalarFieldEnum)[keyof typeof VerificationScalarFieldEnum]


export const TokenScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  hashedToken: 'hashedToken',
  type: 'type',
  expiresAt: 'expiresAt',
  sentTo: 'sentTo',
  userId: 'userId'
} as const

export type TokenScalarFieldEnum = (typeof TokenScalarFieldEnum)[keyof typeof TokenScalarFieldEnum]


export const ProjectScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  slug: 'slug',
  subTitle: 'subTitle',
  partOf: 'partOf',
  description: 'description',
  logoSrc: 'logoSrc',
  partnerLogoSrcs: 'partnerLogoSrcs',
  exportEnabled: 'exportEnabled',
  aiEnabled: 'aiEnabled',
  assignmentRepliesEnabled: 'assignmentRepliesEnabled',
  landAcquisitionModuleEnabled: 'landAcquisitionModuleEnabled',
  showLogEntries: 'showLogEntries',
  evaluationsEnabled: 'evaluationsEnabled',
  externalShareEnabled: 'externalShareEnabled',
  externalShareToken: 'externalShareToken',
  mcpMode: 'mcpMode',
  mcpDirectUntil: 'mcpDirectUntil',
  alkisStateKey: 'alkisStateKey',
  projectLeadId: 'projectLeadId',
  subsubsectionExtraFieldDefinitions: 'subsubsectionExtraFieldDefinitions'
} as const

export type ProjectScalarFieldEnum = (typeof ProjectScalarFieldEnum)[keyof typeof ProjectScalarFieldEnum]


export const McpDraftScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  createdById: 'createdById',
  projectId: 'projectId',
  kind: 'kind',
  subsubsectionId: 'subsubsectionId',
  parentSubsectionId: 'parentSubsectionId',
  slug: 'slug',
  subsectionId: 'subsectionId',
  projectRecordId: 'projectRecordId',
  patch: 'patch'
} as const

export type McpDraftScalarFieldEnum = (typeof McpDraftScalarFieldEnum)[keyof typeof McpDraftScalarFieldEnum]


export const MembershipScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  projectId: 'projectId',
  userId: 'userId',
  role: 'role'
} as const

export type MembershipScalarFieldEnum = (typeof MembershipScalarFieldEnum)[keyof typeof MembershipScalarFieldEnum]


export const ContactScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  firstName: 'firstName',
  lastName: 'lastName',
  email: 'email',
  note: 'note',
  phone: 'phone',
  role: 'role',
  projectId: 'projectId'
} as const

export type ContactScalarFieldEnum = (typeof ContactScalarFieldEnum)[keyof typeof ContactScalarFieldEnum]


export const OperatorScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  order: 'order',
  slug: 'slug',
  title: 'title',
  projectId: 'projectId'
} as const

export type OperatorScalarFieldEnum = (typeof OperatorScalarFieldEnum)[keyof typeof OperatorScalarFieldEnum]


export const SubsectionScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  slug: 'slug',
  order: 'order',
  type: 'type',
  geometry: 'geometry',
  labelPos: 'labelPos',
  description: 'description',
  lengthM: 'lengthM',
  priority: 'priority',
  estimatedCompletionDateString: 'estimatedCompletionDateString',
  projectId: 'projectId',
  managerId: 'managerId',
  operatorId: 'operatorId',
  networkHierarchyId: 'networkHierarchyId',
  subsectionStatusId: 'subsectionStatusId'
} as const

export type SubsectionScalarFieldEnum = (typeof SubsectionScalarFieldEnum)[keyof typeof SubsectionScalarFieldEnum]


export const NetworkHierarchyScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  slug: 'slug',
  title: 'title',
  projectId: 'projectId'
} as const

export type NetworkHierarchyScalarFieldEnum = (typeof NetworkHierarchyScalarFieldEnum)[keyof typeof NetworkHierarchyScalarFieldEnum]


export const SubsubsectionScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  slug: 'slug',
  subTitle: 'subTitle',
  type: 'type',
  location: 'location',
  geometry: 'geometry',
  labelPos: 'labelPos',
  lengthM: 'lengthM',
  width: 'width',
  widthExisting: 'widthExisting',
  description: 'description',
  mapillaryKey: 'mapillaryKey',
  isExistingInfra: 'isExistingInfra',
  maxSpeed: 'maxSpeed',
  trafficLoad: 'trafficLoad',
  trafficLoadDate: 'trafficLoadDate',
  planningPeriod: 'planningPeriod',
  constructionPeriod: 'constructionPeriod',
  estimatedCompletionDate: 'estimatedCompletionDate',
  estimatedConstructionDateString: 'estimatedConstructionDateString',
  costEstimate: 'costEstimate',
  planningCosts: 'planningCosts',
  deliveryCosts: 'deliveryCosts',
  constructionCosts: 'constructionCosts',
  landAcquisitionCosts: 'landAcquisitionCosts',
  expensesOfficialOrders: 'expensesOfficialOrders',
  expensesTechnicalVerification: 'expensesTechnicalVerification',
  nonEligibleExpenses: 'nonEligibleExpenses',
  grantAmount: 'grantAmount',
  ownFunds: 'ownFunds',
  grantsOtherFunding: 'grantsOtherFunding',
  revenuesEconomicIncome: 'revenuesEconomicIncome',
  contributionsThirdParties: 'contributionsThirdParties',
  remainingFunding: 'remainingFunding',
  disbursedFunding: 'disbursedFunding',
  qualityLevelId: 'qualityLevelId',
  managerId: 'managerId',
  subsectionId: 'subsectionId',
  subsubsectionStatusId: 'subsubsectionStatusId',
  subsubsectionTaskId: 'subsubsectionTaskId',
  subsubsectionInfraId: 'subsubsectionInfraId',
  extraFields: 'extraFields'
} as const

export type SubsubsectionScalarFieldEnum = (typeof SubsubsectionScalarFieldEnum)[keyof typeof SubsubsectionScalarFieldEnum]


export const ParcelScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  alkisParcelId: 'alkisParcelId',
  alkisParcelIdSource: 'alkisParcelIdSource',
  geometry: 'geometry'
} as const

export type ParcelScalarFieldEnum = (typeof ParcelScalarFieldEnum)[keyof typeof ParcelScalarFieldEnum]


export const AcquisitionAreaStatusScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  slug: 'slug',
  title: 'title',
  style: 'style',
  projectId: 'projectId'
} as const

export type AcquisitionAreaStatusScalarFieldEnum = (typeof AcquisitionAreaStatusScalarFieldEnum)[keyof typeof AcquisitionAreaStatusScalarFieldEnum]


export const AcquisitionAreaScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  geometry: 'geometry',
  description: 'description',
  bufferRadiusM: 'bufferRadiusM',
  subsubsectionId: 'subsubsectionId',
  parcelId: 'parcelId',
  acquisitionAreaStatusId: 'acquisitionAreaStatusId'
} as const

export type AcquisitionAreaScalarFieldEnum = (typeof AcquisitionAreaScalarFieldEnum)[keyof typeof AcquisitionAreaScalarFieldEnum]


export const QualityLevelScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  slug: 'slug',
  title: 'title',
  url: 'url',
  projectId: 'projectId'
} as const

export type QualityLevelScalarFieldEnum = (typeof QualityLevelScalarFieldEnum)[keyof typeof QualityLevelScalarFieldEnum]


export const SubsubsectionStatusScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  slug: 'slug',
  title: 'title',
  style: 'style',
  projectId: 'projectId'
} as const

export type SubsubsectionStatusScalarFieldEnum = (typeof SubsubsectionStatusScalarFieldEnum)[keyof typeof SubsubsectionStatusScalarFieldEnum]


export const SubsubsectionTaskScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  slug: 'slug',
  title: 'title',
  projectId: 'projectId'
} as const

export type SubsubsectionTaskScalarFieldEnum = (typeof SubsubsectionTaskScalarFieldEnum)[keyof typeof SubsubsectionTaskScalarFieldEnum]


export const SubsubsectionInfraScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  slug: 'slug',
  title: 'title',
  projectId: 'projectId'
} as const

export type SubsubsectionInfraScalarFieldEnum = (typeof SubsubsectionInfraScalarFieldEnum)[keyof typeof SubsubsectionInfraScalarFieldEnum]


export const SubsubsectionInfrastructureTypeScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  slug: 'slug',
  title: 'title',
  projectId: 'projectId'
} as const

export type SubsubsectionInfrastructureTypeScalarFieldEnum = (typeof SubsubsectionInfrastructureTypeScalarFieldEnum)[keyof typeof SubsubsectionInfrastructureTypeScalarFieldEnum]


export const SubsubsectionSpecialScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  slug: 'slug',
  title: 'title',
  projectId: 'projectId'
} as const

export type SubsubsectionSpecialScalarFieldEnum = (typeof SubsubsectionSpecialScalarFieldEnum)[keyof typeof SubsubsectionSpecialScalarFieldEnum]


export const SubsectionStatusScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  slug: 'slug',
  title: 'title',
  style: 'style',
  projectId: 'projectId'
} as const

export type SubsectionStatusScalarFieldEnum = (typeof SubsectionStatusScalarFieldEnum)[keyof typeof SubsectionStatusScalarFieldEnum]


export const UploadScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  title: 'title',
  externalUrl: 'externalUrl',
  collaborationUrl: 'collaborationUrl',
  collaborationPath: 'collaborationPath',
  summary: 'summary',
  mimeType: 'mimeType',
  fileSize: 'fileSize',
  latitude: 'latitude',
  longitude: 'longitude',
  projectId: 'projectId',
  projectRecordEmailId: 'projectRecordEmailId',
  surveyResponseId: 'surveyResponseId',
  supportDocumentId: 'supportDocumentId',
  publicDeleteToken: 'publicDeleteToken',
  externalShareEnabled: 'externalShareEnabled',
  createdById: 'createdById',
  updatedById: 'updatedById'
} as const

export type UploadScalarFieldEnum = (typeof UploadScalarFieldEnum)[keyof typeof UploadScalarFieldEnum]


export const SupportDocumentScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  title: 'title',
  description: 'description',
  order: 'order',
  createdById: 'createdById'
} as const

export type SupportDocumentScalarFieldEnum = (typeof SupportDocumentScalarFieldEnum)[keyof typeof SupportDocumentScalarFieldEnum]


export const SurveyScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  startDate: 'startDate',
  endDate: 'endDate',
  slug: 'slug',
  title: 'title',
  active: 'active',
  interestedParticipants: 'interestedParticipants',
  surveyResultsUrl: 'surveyResultsUrl',
  projectId: 'projectId'
} as const

export type SurveyScalarFieldEnum = (typeof SurveyScalarFieldEnum)[keyof typeof SurveyScalarFieldEnum]


export const SurveySessionScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  surveyId: 'surveyId'
} as const

export type SurveySessionScalarFieldEnum = (typeof SurveySessionScalarFieldEnum)[keyof typeof SurveySessionScalarFieldEnum]


export const SurveyResponseScalarFieldEnum = {
  id: 'id',
  surveyPart: 'surveyPart',
  data: 'data',
  status: 'status',
  note: 'note',
  source: 'source',
  state: 'state',
  surveySessionId: 'surveySessionId',
  operatorId: 'operatorId'
} as const

export type SurveyResponseScalarFieldEnum = (typeof SurveyResponseScalarFieldEnum)[keyof typeof SurveyResponseScalarFieldEnum]


export const SurveyResponseTagScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  title: 'title',
  description: 'description',
  archivedAt: 'archivedAt',
  projectId: 'projectId'
} as const

export type SurveyResponseTagScalarFieldEnum = (typeof SurveyResponseTagScalarFieldEnum)[keyof typeof SurveyResponseTagScalarFieldEnum]


export const SurveyResponseCommentScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  userId: 'userId',
  surveyResponseId: 'surveyResponseId',
  body: 'body'
} as const

export type SurveyResponseCommentScalarFieldEnum = (typeof SurveyResponseCommentScalarFieldEnum)[keyof typeof SurveyResponseCommentScalarFieldEnum]


export const EmailTemplateScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  key: 'key',
  subject: 'subject',
  introMarkdown: 'introMarkdown',
  outroMarkdown: 'outroMarkdown',
  ctaText: 'ctaText',
  updatedById: 'updatedById'
} as const

export type EmailTemplateScalarFieldEnum = (typeof EmailTemplateScalarFieldEnum)[keyof typeof EmailTemplateScalarFieldEnum]


export const EvaluationsPageScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  config: 'config',
  projectId: 'projectId',
  updatedById: 'updatedById'
} as const

export type EvaluationsPageScalarFieldEnum = (typeof EvaluationsPageScalarFieldEnum)[keyof typeof EvaluationsPageScalarFieldEnum]


export const SystemLogEntryScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  userId: 'userId',
  projectId: 'projectId',
  logLevel: 'logLevel',
  message: 'message',
  context: 'context'
} as const

export type SystemLogEntryScalarFieldEnum = (typeof SystemLogEntryScalarFieldEnum)[keyof typeof SystemLogEntryScalarFieldEnum]


export const LogEntryScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  userId: 'userId',
  action: 'action',
  message: 'message',
  changes: 'changes',
  projectId: 'projectId',
  inviteId: 'inviteId',
  membershipId: 'membershipId',
  contactId: 'contactId',
  operatorId: 'operatorId',
  subsectionId: 'subsectionId',
  subsubsectionId: 'subsubsectionId',
  acquisitionAreaId: 'acquisitionAreaId',
  networkhierarchyId: 'networkhierarchyId',
  qualitylevelId: 'qualitylevelId',
  uploadId: 'uploadId',
  surveyResponseId: 'surveyResponseId',
  surveyId: 'surveyId',
  projectRecordId: 'projectRecordId',
  projectRecordCommentId: 'projectRecordCommentId',
  surveyResponseCommentId: 'surveyResponseCommentId',
  supportDocumentId: 'supportDocumentId'
} as const

export type LogEntryScalarFieldEnum = (typeof LogEntryScalarFieldEnum)[keyof typeof LogEntryScalarFieldEnum]


export const ProjectRecordEmailScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  text: 'text',
  date: 'date',
  from: 'from',
  subject: 'subject',
  textBody: 'textBody',
  discardedAt: 'discardedAt',
  discardedById: 'discardedById',
  projectId: 'projectId'
} as const

export type ProjectRecordEmailScalarFieldEnum = (typeof ProjectRecordEmailScalarFieldEnum)[keyof typeof ProjectRecordEmailScalarFieldEnum]


export const ProjectRecordScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  date: 'date',
  title: 'title',
  body: 'body',
  editingState: 'editingState',
  projectId: 'projectId',
  subsubsectionId: 'subsubsectionId',
  acquisitionAreaId: 'acquisitionAreaId',
  userId: 'userId',
  projectRecordAuthorType: 'projectRecordAuthorType',
  assignedToId: 'assignedToId',
  assignedById: 'assignedById',
  assignedAt: 'assignedAt',
  updatedById: 'updatedById',
  projectRecordUpdatedByType: 'projectRecordUpdatedByType',
  projectRecordEmailId: 'projectRecordEmailId',
  projectRecordTemplateId: 'projectRecordTemplateId',
  reviewState: 'reviewState',
  reviewedAt: 'reviewedAt',
  reviewedById: 'reviewedById',
  reviewNotes: 'reviewNotes'
} as const

export type ProjectRecordScalarFieldEnum = (typeof ProjectRecordScalarFieldEnum)[keyof typeof ProjectRecordScalarFieldEnum]


export const ProjectRecordCommentScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  userId: 'userId',
  projectRecordId: 'projectRecordId',
  body: 'body'
} as const

export type ProjectRecordCommentScalarFieldEnum = (typeof ProjectRecordCommentScalarFieldEnum)[keyof typeof ProjectRecordCommentScalarFieldEnum]


export const TagScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  title: 'title',
  description: 'description',
  color: 'color',
  archivedAt: 'archivedAt',
  projectId: 'projectId'
} as const

export type TagScalarFieldEnum = (typeof TagScalarFieldEnum)[keyof typeof TagScalarFieldEnum]


export const ProjectRecordTemplateScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  templateTitle: 'templateTitle',
  entryTitle: 'entryTitle',
  body: 'body',
  purpose: 'purpose'
} as const

export type ProjectRecordTemplateScalarFieldEnum = (typeof ProjectRecordTemplateScalarFieldEnum)[keyof typeof ProjectRecordTemplateScalarFieldEnum]


export const FormTemplateScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  title: 'title',
  slug: 'slug',
  bodyMarkdown: 'bodyMarkdown',
  fields: 'fields',
  type: 'type',
  updatedById: 'updatedById'
} as const

export type FormTemplateScalarFieldEnum = (typeof FormTemplateScalarFieldEnum)[keyof typeof FormTemplateScalarFieldEnum]


export const MetaScalarFieldEnum = {
  key: 'key',
  value: 'value'
} as const

export type MetaScalarFieldEnum = (typeof MetaScalarFieldEnum)[keyof typeof MetaScalarFieldEnum]


export const SortOrder = {
  asc: 'asc',
  desc: 'desc'
} as const

export type SortOrder = (typeof SortOrder)[keyof typeof SortOrder]


export const JsonNullValueInput = {
  JsonNull: JsonNull
} as const

export type JsonNullValueInput = (typeof JsonNullValueInput)[keyof typeof JsonNullValueInput]


export const NullableJsonNullValueInput = {
  DbNull: DbNull,
  JsonNull: JsonNull
} as const

export type NullableJsonNullValueInput = (typeof NullableJsonNullValueInput)[keyof typeof NullableJsonNullValueInput]


export const QueryMode = {
  default: 'default',
  insensitive: 'insensitive'
} as const

export type QueryMode = (typeof QueryMode)[keyof typeof QueryMode]


export const NullsOrder = {
  first: 'first',
  last: 'last'
} as const

export type NullsOrder = (typeof NullsOrder)[keyof typeof NullsOrder]


export const JsonNullValueFilter = {
  DbNull: DbNull,
  JsonNull: JsonNull,
  AnyNull: AnyNull
} as const

export type JsonNullValueFilter = (typeof JsonNullValueFilter)[keyof typeof JsonNullValueFilter]

